<template>
  <div>
    <div>
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />

      <tl-header type="h1">Salary Grades</tl-header>
      <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
        You have only view permission.
      </div>
      <br />
      <div class="noData" v-show="ifTeamleaderPermission">
        <span class="text">Click on ‘Add New’ to add new Salary Grade in the following list</span>
        <div>
          <button class="addnewbtn" v-if="salaryGradesData.length>3" @click="initCreateForm()">
            <img src="@/assets/group-5.svg" />
            <b>Add New</b>
          </button>
        </div>
      </div>
      <div class v-show="salaryGradesData.length" :disabled="!(ifTeamleaderPermission)">
        <data-table
          :columns="salaryGradesColumnNames"
          :tableData="salaryGradesData"
          :checkbox="false"
          :withForm="false"
          @editStart="initEditStart"
          @delete="deleteItem"
          :showhistory="false"
        />
      </div>

      <pop-up-message
        v-if="showPopup"
        :message="popupMessage"
        :popupType="popupType"
        :popupHeaderMessage="'Confirm Delete'"
      >
        <!-- Author: Vaishnavi
        Date: 10/12/2019
        Issue Description: Consistent buttons across application-->
        <template v-slot:bottomContent>
          <btn-grp>
            <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
            <popup-btn text="Delete" type="primary" @click="deleteEvent" />
          </btn-grp>
        </template>
      </pop-up-message>

      <div v-show="ifTeamleaderPermission">
        <form-add-button
          v-if="salaryGradesData.length<=3"
          v-show="showAddBtn"
          main_text="+ Add New"
          sub_text="Salary Grade"
          @click="initCreateForm()"
        ></form-add-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "Grades",
  data() {
    return {
      errmsg: "",
      toast: false,
      showAdd: true,
      mode: "add",
      popupType: "Success",
      popupMessage: "",
      showButton: true,
      showPopup: false,
      isFormActive: false,
      errmsg: "",
      currentRecord: {},
      salaryGradeValue: false,
      role: ""
    };
  },
  mounted() {
    this.getOrgLeIdList();
  },
  activated() {
    // this.fetchAll();
    this.getOrgLeIdList();
  },
  computed: {
    ...mapState("onboard/salary_grades", {
      salaryGradesDataAll: state => state.data,
      isFetching: state => state.isFetching,
      isSaving: state => state.isSaving,
      isDeleting: state => state.isDeleting
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    salaryGradesColumnNames() {
      return [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Description",
          key: "description"
        }
      ];
    },
    salaryGradesData() {
      return this.salaryGradesDataAll
        ? this.salaryGradesDataAll[this.leId]
        : [];
    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    showAddBtn() {
      return !this.isFormActive;
    },
    isLoading() {
      return this.isFetching;
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.salaryGradeValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.salaryGradeValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  methods: {
    ...mapActions("onboard/salary_grades/", {
      act_fetchAll: "fetchAll",
      act_delete: "delete",
      act_create: "create",
      act_update: "update",
      act_changeEditMode: "changeEditMode"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /* function to hide pop-up */
    cancelEvent() {
      this.showPopup = false;
    },

    /* function to open delete confirmation pop-up */
    deleteItem(record) {
      try {
        this.showPopup = true;
        this.popupType = "ConfirmDelete";
        this.popupMessage = "Are you sure you want to delete ?";
        this.currentRecord = record;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get grdaes */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.leId);

      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to go to create grade page */
    async initCreateForm() {
      try {
        await this.act_changeEditMode({ editMode: false, record: {} });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/addGrades`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to go to edit grade(create grade page) */
    async initEditStart(record) {
      try {
        await this.act_changeEditMode({ editMode: true, record: record });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/modifyGrades`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to delete grade */
    async deleteEvent() {
      try {
        await this.act_delete([this.currentRecord, this.leId]);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
      this.showPopup = false;
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.leId;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.salaryGradeValue = data.data.user.permissions.salary_grade ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/form.scss";

.noData {
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
